export default __webpack_public_path__ + "static/media/Nessus.9ad8610b.svg";